module.exports = __webpack_public_path__ + "media/searching_bookmarks/icon_search-c6aa07cb.svg";